import { Know } from 'interfaces/Know'
import { FolderRequest, FolderUpdateRequest, KnowFolder } from 'interfaces/KnowFolder'
import ApiService from './ApiService'
import { OffsetPaginationResponse } from 'interfaces/Pagination'

const LibraryService = {
    listFolders(userUuid: string, listAllFolders?: boolean) {
        return ApiService.get(
            `/users/${userUuid}/folders${listAllFolders ? `?includeSaved=true&includeStudyLater=true` : ''} `
        ).then((response) => {
            return response.data.content as KnowFolder[]
        })
    },

    createFolder(folderRequest: FolderRequest) {
        return ApiService.post(`/folders`, folderRequest).then((response) => {
            return response.data
        })
    },

    getFolder(uuid: string) {
        return ApiService.get(`/folders/${uuid}`).then((response) => {
            return response.data as KnowFolder
        })
    },

    updateFolder(uuid: string, folderRequest: FolderUpdateRequest) {
        return ApiService.patch(`/folders/${uuid}`, folderRequest).then((response) => {
            return response.data as KnowFolder
        })
    },

    deleteFolder(uuid: string) {
        return ApiService.delete(`/folders/${uuid}`).then((response) => {
            return response.data as KnowFolder
        })
    },

    addKnowToFolder(uuid: string, knowUuid: string) {
        return ApiService.post(`/folders/${uuid}/knows`, [knowUuid]).then((response) => {
            return response.data as KnowFolder
        })
    },

    getFoldersForKnow(knowUuid: string) {
        return ApiService.get(`/knows/${knowUuid}/folders`).then((response) => {
            return response.data as KnowFolder
        })
    },

    getKnowsWithinFolder(uuid: string, page = 0) {
        return ApiService.get(`/folders/${uuid}/knows?page=${page}`).then((response) => {
            return response.data as OffsetPaginationResponse<Know>
        })
    },

    getSyncedKnowsFolder() {
        return ApiService.get(`/folders/synced-to-web`).then((response) => {
            return response.data.content as Know[]
        })
    },

    getRecentlyViewed() {
        return ApiService.get(`/feeds/recently-viewed`).then((response) => {
            return response.data
        })
    },
}

export default LibraryService
